import React, { Component, useState } from "react";
import { Paper } from "@material-ui/core";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import NewPurchase from "./newPurchaseForm";
import NewPurchaseConfirm from "./newPurchaseConfirm";
import AdditionalPurchase from "./additionalPurchaseForm";
import Redemption from "./redemption";
import switchCmponent from "./switch";
import Sip from "./sip";
import Swp from "./swp";
import { STP } from "./stp/index";
import NfoPhysicalMode from "./nfoPhysicalMode";
import Image from "../../Image";
import SipCancellation from "./sipCancellation";
import NctType from "./nctType";
import Nominee from "../UpdateNominee";
import ChangeEmail from "../ChangeEmail";
import ChangeEmailList from "../ChangeEmail/change-email-list";
import ENACH from "./eNach";
import { userPan } from "../../../store/actions/auth";
import { getInvestorDetails } from "../../../store/actions";
import CustomLoader from "../../forms/Loader";
import ChangeMobileNew from "../ChangeMobile/newMobile";
import ChangeMobile from "../ChangeMobile";
import changeEmailDocument from "../ChangeEmail/change-email-document";
import changeMobileDocument from "../ChangeMobile/change-mobile-document";
import FatcaDeclaration from "../FatcaDeclaration";
import ChangeIdcw from "../ChangeIdcw";
import ChangeDividendSuccess from "../ChangeIdcw/change-dividend-success";
import ConsolidationFolios from "../ConsolidationFolios";
import ConsolidationSourceFolios from "../ConsolidationFolios/consolidationSourceFolios";
import ConsolidationFoliosSuccess from "../ConsolidationFolios/consolidation-folios-success";
import ConsolidationFoliosFailure from "../ConsolidationFolios/consolidation-folios-failed";
import ChangeBank from "../ChangeBank";
import changeBankSelected from "../ChangeBank/change-bank-selected";
import UpdateIFSC from "../UpdateIFSC";
import updateIfscDetails from "../UpdateIFSC/update-ifsc-details";
import UpdateIFSCSuccess from "../UpdateIFSC/update-ifsc-success";
import correctionFoliosSelection from "../CorrectionFolios/correction-folios-selection";
import CorrectionFolios from "../CorrectionFolios";
import SuccessScreen from "../SuccessScreen";
import BankMandate from "../BankMandate";
import bankMandateAddBank from "../BankMandate/bank-mandate-add-bank";
import bankMandateDeleteSelected from "../BankMandate/bank-mandate-delete-selected";
import bankMandateSelected from "../BankMandate/bank-mandate-selected";

class NFOAndNewPurchaseDigital extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: false,
    };
  }
  async componentDidMount() {
    if (
      !!this?.props?.location?.state?.pan ||
      !!this?.props?.location?.state?.Pan
    ) {
      this.setState({
        display: true,
      });
      await this.props.userPan(this.props.location.state.pan);
      this.setState({
        display: false,
      });
    }
  }
  render() {
    const { investorData } = this.props;

    return (
      <div>
        <CustomLoader display={!!this.state.display} />

        <Paper
          className="digital-form-container"
          style={{
            boxShadow: "0px 0px 2px 0px lightgray",
            marginLeft: 10,
            marginRight: 10,
          }}
        >
          {this.props.nomineeFlag &&
          this.props.match.path.includes("nct-type") ? null : (
            <div className="digital-form-left-div">
              <List
                investorData={investorData}
                pan={!!this.props.user_pan ? this.props.user_pan : ""}
              />
            </div>
          )}

          <div className="digital-form-Right-div">
            <Switch>
              <Route
                exact
                path={`/new-transaction/nfo-new-purchase/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/additional-purchase/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/redemption/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/switch/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/sip/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/stp/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/swp/physical/transact`}
                component={NfoPhysicalMode}
              />
              <Route
                exact
                path={`/new-transaction/nfo-new-purchase/digital/transact`}
                component={NewPurchase}
                pan={!!this.props.user_pan ? this.props.user_pan : ""}
              />
              <Route
                exact
                path={`/new-transaction/nfo-new-purchase/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />
              <Route
                exact
                path={`/new-transaction/additional-purchase/digital/transact`}
                component={AdditionalPurchase}
              />
              <Route
                exact
                path={`/new-transaction/additional-purchase/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />

              <Route
                exact
                path={`/new-transaction/redemption/digital/transact`}
                component={Redemption}
              />
              <Route
                exact
                path={`/new-transaction/redemption/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />

              <Route
                exact
                path={`/new-transaction/switch/digital/transact`}
                component={switchCmponent}
              />
              <Route
                exact
                path={`/new-transaction/switch/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />
              <Route
                exact
                path={`/new-transaction/sip/digital/transact`}
                component={Sip}
              />
              <Route
                exact
                path={`/new-transaction/sip/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />

              <Route
                exact
                path={`/new-transaction/swp/digital/transact`}
                component={Swp}
              />
              <Route
                exact
                path={`/new-transaction/swp/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />
              <Route
                exact
                path={`/new-transaction/stp/digital/transact`}
                component={STP}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/updateNominee`}
                component={Nominee}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/facta-declaration`}
                component={FatcaDeclaration}
              />
              <Route
                exact
                path={`/new-transaction/stp/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />

              <Route
                exact
                path={`/new-transaction/nct-type/digital/transact`}
                component={NctType}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/change-email`}
                component={ChangeEmail}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/change-idcw`}
                component={ChangeIdcw}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/consolidation-folios`}
                component={ConsolidationFolios}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/consolidate-source-folios`}
                component={ConsolidationSourceFolios}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/consolidation-folios-success`}
                component={SuccessScreen}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/consolidation-folios-failure`}
                component={ConsolidationFoliosFailure}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/change-dividend-success`}
                component={ChangeDividendSuccess}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/change-bank`}
                component={ChangeBank}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/change-bank-selected`}
                component={changeBankSelected}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/bank-mandate`}
                component={BankMandate}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/bank-mandate-add-bank`}
                component={bankMandateAddBank}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/bank-mandate-delete-selected`}
                component={bankMandateDeleteSelected}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/bank-mandate-selected`}
                component={bankMandateSelected}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/bank-mandate-success`}
                component={SuccessScreen}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/update-ifsc`}
                component={UpdateIFSC}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/update-ifsc-details`}
                component={updateIfscDetails}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/update-ifsc-success`}
                component={UpdateIFSCSuccess}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/change-dividend-success`}
                component={ChangeDividendSuccess}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/correction-folios`}
                component={CorrectionFolios}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/correction-folios-success`}
                component={SuccessScreen}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/correction-folios-selection`}
                component={correctionFoliosSelection}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/phygital/change-email`}
                component={ChangeEmail}
              />

              <Route
                exact
                path={`/new-transaction/nct-type/digital/change-mobile`}
                component={ChangeMobileNew}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/phygital/change-mobile`}
                component={ChangeMobileNew}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/digital/change-mobile-list`}
                component={ChangeMobile}
              />

              <Route
                exact
                path={`/new-transaction/nct-type/digital/change-email-list`}
                component={ChangeEmailList}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/phygital/change-email-document`}
                component={changeEmailDocument}
              />
              <Route
                exact
                path={`/new-transaction/nct-type/phygital/change-mobile-document`}
                component={changeMobileDocument}
              />

              <Route
                exact
                path={`/new-transaction/nct-type/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />
              <Route
                exact
                path={`/new-transaction/sip-cancellation/digital/transact`}
                component={SipCancellation}
              />
              <Route
                exact
                path={`/new-transaction/sip-cancellation/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />
              <Route
                exact
                path={`/new-transaction/eNACH/digital/transact`}
                component={ENACH}
              />
              <Route
                exact
                path={`/new-transaction/eNACH/digital/transact/confirm`}
                component={NewPurchaseConfirm}
              />
            </Switch>
          </div>
        </Paper>
      </div>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const { investorData, user_pan, userId, nomineeFlag } = authReducer;
    return { investorData, user_pan, userId, nomineeFlag };
  },
  { userPan, getInvestorDetails }
)(NFOAndNewPurchaseDigital);

export class List extends Component {
  render() {
    const { invname, PAN } = this.props.investorData;
    return (
      <div
        // className="digital_mode_investor_sec"
        style={{
          borderBottom: "1px solid lightgray",
          margin: "0px 10px",
        }}
      >
        <div className="digital-form-investor-list ">
          <Image
            src={"/images/user.png"}
            alt="user_icon"
            style={{ height: 35 }}
          />
          <div className="digital-form-text-container">
            <div className="digital-form-main-text">
              {!!invname ? invname : ""}
            </div>
            <div className="digital-form-sub-text">
              {" "}
              PAN: {PAN || this.props.pan}
            </div>
          </div>
          {!!this.props.image && (
            <div>
              <Image
                alt="secondary_image"
                src={`${this.props.image}`}
                height={this.props.height}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
